import { NavigateFunction } from 'react-router'

import { onboardingStepToPath } from '../constants/onboardingStepPathMapping'
import { OnboardingSetupStep } from '../types'

interface NavigateToOnboardingStepOptions {
  baseUrl?: string
  navigate: NavigateFunction
  step: OnboardingSetupStep
  updateCurrentStep: (step: OnboardingSetupStep) => void
}

export const navigateToOnboardingStep = (props: NavigateToOnboardingStepOptions) => {
  const { baseUrl, navigate, step, updateCurrentStep } = props

  navigate(`${baseUrl}/${onboardingStepToPath[step]}`)
  updateCurrentStep(step)
}
